import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Module crashed:', error, info?.componentStack);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return (
        <div className="card p-8 max-w-2xl mx-auto mt-8" data-testid="module-error">
          <h3 className="font-heading font-bold text-lg mb-2">Terjadi kesalahan saat memuat modul ini</h3>
          <p className="text-sm text-muted-foreground mb-4">
            {String(this.state.error?.message || this.state.error)}
          </p>
          <button className="btn-primary" onClick={this.reset}>
            Coba lagi
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
